import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { Reveal } from "@/components/ui-ext/Reveal";

const QUOTES = [
  {
    q: "They took a 40-year-old website and made it feel like a modern product. The Austin traffic followed — and so did the booked service appointments.",
    a: "Marketing Lead",
    r: "Foreign Affairs Auto · South Austin, TX",
  },
  {
    q: "First agency we've worked with that treats a monthly SEO report like a leadership document, not a homework assignment. Our board reads it end-to-end.",
    a: "Founder & CEO",
    r: "Lynx Systems · Austin, TX",
  },
  {
    q: "Our booked HVAC jobs from organic went from a trickle to our #1 lead source across Round Rock, Cedar Park and North Austin. And they can explain exactly why.",
    a: "Operations Manager",
    r: "Air Tech Pro HVAC · Central Texas",
  },
  {
    q: "The roadmap was so specific it felt more like an engineering plan than an SEO deck. We finally understand what we're paying for — and rank in the Austin local pack for the terms that actually close.",
    a: "Owner",
    r: "Carage Auto · Austin, TX",
  },
];

export function HomeTestimonials() {
  return (
    <section className="container-page py-24 md:py-32">
      <SectionHeading
        eyebrow="Austin client results, in their words"
        title={<>What Austin operators say when <span className="text-gradient">the numbers show up</span>.</>}
      />
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {QUOTES.map((q, i) => (
          <Reveal key={q.r} delay={(i % 4) as 0 | 1 | 2 | 3}>
            <figure className="surface-card p-7 h-full flex flex-col">
              <div
                aria-hidden
                className="font-display text-6xl leading-none text-primary/40"
              >
                &ldquo;
              </div>
              <blockquote className="mt-2 text-lg leading-relaxed text-foreground/95">
                {q.q}
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-border text-sm">
                <div className="font-medium text-foreground">{q.a}</div>
                <div className="text-muted-foreground">{q.r}</div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
